












































import Target from "@/models/Grp/Target";
import GrpTargetMixin from "@/mixins/http/Grp/Target";
import GrpTargetShow from "@/components/GrpTargets/Show.vue";
import { Component, Mixins, Prop } from "vue-property-decorator";

const STATUS_DEFAULT = "default";
const STATUS_EDIT = "edit";
const MAX_ELEMENTS_COUNT = 10;

@Component({
  components: { GrpTargetShow },
})
export default class GrpTargetEditor extends Mixins(GrpTargetMixin) {
  @Prop({ default: MAX_ELEMENTS_COUNT }) readonly maxElements?: number;

  status: string = STATUS_DEFAULT;

  current: Target = new Target({});

  targets: Target[] = [];
  loading = false;

  selected: Target | null = null;

  get isEditing(): boolean {
    return this.status === STATUS_EDIT;
  }

  get isSelected(): boolean {
    return this.selected !== null;
  }

  get isDestroyable(): boolean {
    return this.targets.length > 1;
  }

  created() {
    this.load();
  }

  startCreating() {
    this.$emit("create");
  }

  async load() {
    this.loading = true;
    this.targets = await this.getTargets();
    this.sortTargets();
    this.loading = false;
    this.$emit("ready", true);
  }

  select(target: Target) {
    this.status = STATUS_DEFAULT;
    this.selected = target;

    this.emitSelected();
  }

  sortTargets() {
    const customTargets = this.targets
      .filter((t) => t.isCustom)
      .sort((a, b) => (a.name.toUpperCase() >= b.name.toUpperCase() ? 1 : -1));
    const userTargets = this.targets
      .filter((t) => !t.isCustom)
      .sort((a, b) => (a.name.toUpperCase() >= b.name.toUpperCase() ? 1 : -1));
    this.targets = [...customTargets, ...userTargets];
  }

  public selectFirst() {
    if (this.targets.length) {
      this.selected = this.targets[0];
      this.emitSelected();
    }
  }

  public selectById(id: string) {
    const target = this.targets.find((target: Target) => target.id == id);
    if (target) {
      this.select(target);
    }
  }

  protected emitSelected() {
    this.$emit("selected", this.selected);
  }

  async onTargetChange(target: Target) {
    await this.updateTarget(target.id, target.name);
    this.selectById(target.id);
    if (this.selected) {
      this.selected.name = target.name;
    }
  }

  async onTargetDeleted(target: Target) {
    await this.deleteTarget(target.id);
    this.load();
    this.selectFirst();
  }
}
